<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2f" id="intro"><a id="page_8">INTRODUCTION<br/><img alt="Image" src="images/chimg.jpg"/></a></h2><a id="page_8">
<p class="noindent">This book will take you on a journey into the past and into the future. My main goal is to give you the tools for reflection so that you can craft a life that you love <em>today</em>. It has been broken into six sections, with each section representing a different stage of the process of crafting a life you love.</p>
</a><p class="blist1"><a id="page_8">• In </a><a href="#/xhtml/part01#part01">Part One</a>, Crafting the Soul, we learn why crafting is so important and, specifically, how to discover what it is that you love to do. You will get permission to spend time crafting each and every day, and you will see that, in fact, spending time developing your hobbies might just be the most important part of your day.</p>
<p class="blist1">• In <span href="#/xhtml/part02#part02" title="Link target outside of Sample">Part Two</span>, Crafting the Right Mindset, we examine how to reframe your thoughts and outlook to better position yourself to grab control of your own happiness.</p>
<p class="blist1">• In <span href="#/xhtml/part03#part03" title="Link target outside of Sample">Part Three</span>, Crafting the Right Environment, we look at your environment—physical and mental—and discuss how to change and update your surroundings to live the best possible life.</p>
<p class="blist1"><a id="page_9">• </a><span href="#/xhtml/part04#part04" title="Link target outside of Sample">Part Four</span>, Crafting Happiness Through Habits, is packed with some of my favorite practical tips for creating positive habits to feed your creative soul.</p>
<p class="blist1">• <span href="#/xhtml/part05#part05" title="Link target outside of Sample">Part Five</span>, Crafting Your Way Back, and <span href="#/xhtml/part06#part06" title="Link target outside of Sample">Part Six</span>, Crafting Your Passions (a brand-new chapter created for this new edition of the book!), give you tools and inspiration for the future.</p>
<p class="noindent1">Each chapter of this book ends with an exercise (or practice) to help you move one step closer to the life of your dreams.</p>
<p class="noindent1"><img alt="Image" src="images/f0009-01.jpg"/></p>
<p class="noindent">—AMY<a id="page_10"></a></p><a id="page_10">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// intro.vue?952fc996